import Vue from "vue"
import "./plugins/vuetify"
import "./plugins/vuetify"
import App from "./App.vue"
import router from "./router"
import store from "./store"
import "vuetify/dist/vuetify.min.css"
import "roboto-fontface/css/roboto/roboto-fontface.css"
import "material-design-icons-iconfont/dist/material-design-icons.css"
import axios from "axios"
import moment from "moment"
import momentTZ from 'moment-timezone'
import vuetify from "./plugins/vuetify"
import ApolloClient from "apollo-boost";
import VueApollo from 'vue-apollo'

Vue.config.productionTip = false
Vue.prototype.$axios = axios
Vue.prototype.$moment = moment
Vue.prototype.$momentTz = momentTZ
Vue.prototype.$print = print

const client = new ApolloClient({
  uri: "https://us-central1-genetictrust-dev.cloudfunctions.net/api/gql"
});

const apolloProvider = new VueApollo({
  defaultClient: client
});

Vue.use(VueApollo);


axios.interceptors.request.use(request =>
  {
    // Do something before request is sent
    let token = store.state.user.idToken
    if(token !== undefined){
      request.headers['Authorization'] = `Bearer ${ token }`;
    }
    return request;
  },
  function(error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(response =>
  {
    // Do something before request is sent
  
    return response;
  },
  function(error) {
    return Promise.reject(error);
  }
);

new Vue({
  router,
  store,
  vuetify,
  apolloProvider,
  render: h => h(App)
}).$mount("#app")
